module.exports = __webpack_public_path__ + "img/all.585a944a.svg";